import React, {Component} from 'react';

import './ShareModuleDummyDiv.css';

class ShareModuleDummyDiv extends Component {

    render() {
        return(
            <div id="dummy-div">
                <div className="dummy-top-section">
                    <div className="dummy-blurb-and-acronym">
                        <div className="dummy-blurb">Hi I'm <span className="dummy-name">{this.props.name}</span>, my skin type is:</div>
                        <div className="acronym-section">
                            <div className="dummy-acronym">{this.props.skinTypeAcronym.replace("W", "M")}</div>
                        </div>
                                   
                        <div className="skin-type">
                            <div className="column">
                                <img alt={ this.props.dryOily } src={ "/images/onboarding/skintypeupdated/" + this.props.dryOily + ".svg" } />
                                <div className="type">{ this.props.dryOily }</div>
                            </div>
                            <div className="column">
                                <img alt={ this.props.sensitiveResistant } src={ "/images/onboarding/skintypeupdated/" + this.props.sensitiveResistant + ".svg" } />
                                <div className="type">{ this.props.sensitiveResistant }</div>
                            </div>
                            <div className="column">
                                <img alt={ this.props.pigmented } src={ "/images/onboarding/skintypeupdated/" + this.props.pigmented + ".svg" } />
                                <div className="type">{ this.props.pigmented }</div>
                            </div>
                            <div className="column">
                                <img alt={ this.props.wrinkled } src={ "/images/onboarding/skintypeupdated/" + this.props.wrinkled + ".svg" } />
                                <div className="type">{ this.props.wrinkled }</div>
                            </div>
                        </div>

                     </div>

                    <div className="dummy-image">
                        <img alt="Your skin profile" src={"/images/onboarding/skinprofile/" + (this.props.genderId === 2 ? "male-share" : "female-share") + ".svg"} />
                    </div>
                </div>
                <div className="dummy-summary">
                    <div className="dummy-summary-title">SUMMARY</div>
                    <div className="dummy-summary-body">{this.props.summary}</div>

                </div>
            </div>
        );
    }
}
export default ShareModuleDummyDiv;



// WEBPACK FOOTER //
// ./src/components/onboarding/ShareModuleDummyDiv.js